import InlineAutocomplete from './InlineAutocomplete'

export type {InlineAutocompleteProps} from './InlineAutocomplete'
export type {ShowSuggestionsEvent, Suggestion, Suggestions, Trigger} from './types'

export default InlineAutocomplete
